import type { Orders } from '../../types/Orders';

export const ordersBaseFeatureConfig: Orders = {
    historyUrlPath: 'netbanking/my/securities/<%=securityId%>/orders/<%=orderId%>/history',
    showDetailAtBest: false,
    showDateHelpIcon: false,
    showExtendedDetailsView: false,
    showFeesPriceNote: false,
    showOpenOrders: false,
    showPortfolioDropdown: false,
    showStatement: false,
    stickyHeaderMobile: false,
    typesNotToShowISIN: [],
    typesNotToShowSellValidFromDate: [],
    typesToShowCouponInfo: [],
    typesToShowSubType: [],
    version: 2,
};
